import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  updateFirstPageData,
  healthEnquiryAPI,
  fgHealthQuote,
  removeHealthQuoteBySlug,
  resetHealthQuoteRedux,
} from '../../Redux/HealthRedux';
import { MainContainer, SkeletonContainer } from './styles';
import PlanCard from './../../pages/Health/quotation.jsx';
import Footer from './../../components/Footer/FooterNew';
import { Pagination } from './../../components/pagination/Pagination';
import { ViewDetailsPopup } from './../../components/view-details-popup/ViewDetailsPopup';
import {
  TbSortAscendingNumbers,
  TbSortDescendingNumbers,
} from 'react-icons/tb';
import { FilterBar } from './../../components/Health-Filter-Bar/FilterBar';
import './gridCss.css';

import FooterNew from '../../components/Footer/FooterNew';
import { SkeletonComponent } from '../../components/skeleton-component/SkeletonComponent';
import Health from './../../components/insurancePolicy/insurancePolicy';
import { fetchData } from '../admin/Promises.js';

export const HealthMainScreen = () => {
  const userData = JSON.parse(localStorage.getItem('userDetails'));
  let combinedRedux = useSelector((state) => state.health.combinedRedux);
  const [resetRedux, setResetRedux] = useState(false);
  const HealthRedux = useSelector((state) => state.health.health);
  const [firstCall, setFirstCall] = useState(false);
  const healthQuote = useSelector((state) => state.health.healthQuote);
  const [healthQuoteState, setHealthQuoteState] = useState([]);


  const [detailsInfo, setDetailsInfo] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [selectedView, setSelectedView] = useState('list');
  const [viewMoreDetails, setViewMoreDetails] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // For the Responsive Screen
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [viewMobileFilter, setViewMobileFilter] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const hideFilter = () => {
    setViewMobileFilter(!viewMobileFilter);
  };

  // Testing Area ==============================
  const hasRunRef = useRef(false);
  useEffect(() => {
    const fetchData = async () => {
      const nObj = { ...combinedRedux };
      const { _id, ...rest } = nObj;

      const hasEnquiryId = rest && rest.hasOwnProperty('enquiryId');

      if (hasEnquiryId) {

        if (healthQuote.length === 0) {
          await callQuoteAPIs(); // Call the API if necessary
        }
      } else {
        const queryParameter = new URLSearchParams(window.location.search);
        const enquiryIds = queryParameter.get('enquiryId');
        if (enquiryIds) {
          const obj = { enquiryId: enquiryIds };
          await dispatch(healthEnquiryAPI(obj)); // Dispatch API call
          setFirstCall(true);
        }
      }
    };

    // Check if combinedRedux is empty and fetch data only if not done already
    if (
      (!combinedRedux || Object.keys(combinedRedux).length === 0) &&
      !hasRunRef.current
    ) {
      fetchData(); // Trigger the fetchData function
      hasRunRef.current = true; // Mark that the data fetching has been done
    }
  }, [combinedRedux, dispatch]);

  useEffect(() => {
    if (firstCall) {
      callQuoteAPIs();
    }
  }, [firstCall]);

  useEffect(() => {
    setHealthQuoteState(healthQuote);
  }, [healthQuote]);

  useEffect(() => {
    if (healthQuote.length > 0) {
      setLoading(false);
    }
  }, [healthQuote]);

  useEffect(() => {
    if (combinedRedux && resetRedux) {
      callQuoteAPIs();
      setResetRedux(false);
    }
  }, [combinedRedux, resetRedux]);

  const callQuoteAPIs = async () => {
    setResetRedux(false);
    console.log('CallQuoteAPIs are ----->', combinedRedux);

    try {
      // start
      if (combinedRedux && combinedRedux.enquiryId) {
        // Make the healthEnquiryAPI call and wait for its response
        const response = await dispatch(
          healthEnquiryAPI({ enquiryId: combinedRedux.enquiryId })
        );
        const healthQuoteData = response.payload.data;
        
        // Reset healthQuoteRedux
        dispatch(resetHealthQuoteRedux(''));

        if (healthQuoteData) {
          await Promise.all([dispatch(fgHealthQuote(healthQuoteData))]);
        }
      }
    } catch (error) {
      console.error('Error in fetchAndProcessQuotes:', error);
    }
    // end
  };
  // end Testing Area ==========================

  // Hardcoded data for the quote state and plans
  const lifeQuoteState = [
    {
      id: 2,
      slug: 'life-hdfc',
      sluginfo: {
        logo: 'https://via.placeholder.com/150',
        name: 'HDFC Health Insurance',
      },
      sumAssured: 1500000,
      roomRentLimit: 'upto Sum Insured',
      preExistingDisease: 'Covered after 4 years',
      tenure: 20,
      totalPriceWithoutTax: 18000,
      serviceTax: 2000,
      mode: 'Annually',
      totalBenefit: 1400000,
    },
  ];

  // Sorting logic
  const [sortingOrder, setSortingOrder] = useState('asc');
  const handlePremiumIcon = () => {
    setSortingOrder(sortingOrder === 'asc' ? 'desc' : 'asc');
  };

  const sortLifeQuoteStateByPremium = (quoteState, sortingOrder) => {
    return quoteState.sort((a, b) => {
      return (
        (sortingOrder === 'asc' ? 1 : -1) *
        (a.totalPriceWithoutTax - b.totalPriceWithoutTax)
      );
    });
  };

  const sortedLifeQuoteState = sortLifeQuoteStateByPremium(
    lifeQuoteState,
    sortingOrder
  );

  const handleCsrIcon = () => {
    // Add CSR sorting if needed
  };

  const ViewBar = () => {
    return (
      <div className="h-div-apart">
        <div className="menuText">
          <div className="textOne">
            <p style={{ width: '240px' }}>Company & Plan Name</p>
            <p className="mainText">Sum Assured</p>
            <p className="mainText">Tenure</p>
            {/* <p className="mainText">Room Rent</p> */}
            <p className="mainText"> Pre-Existing Diseases</p>
            {/* <p className="mainText csr-column" onClick={handleCsrIcon}>
              Claim Settlement Ratio
              {sortingOrder === 'asc' ? (
                <TbSortAscendingNumbers
                  style={{
                    color: '#430643',
                    fontSize: '20px',
                    marginLeft: '10px',
                  }}
                />
              ) : (
                <TbSortDescendingNumbers
                  style={{
                    color: '#430643',
                    fontSize: '20px',
                    marginLeft: '10px',
                  }}
                />
              )}
            </p> */}
            <p className="mainText premium-column" onClick={handlePremiumIcon}>
              Premium
              {sortingOrder === 'desc' ? (
                <TbSortDescendingNumbers
                  style={{
                    color: '#41025F',
                    fontSize: '20px',
                    marginLeft: '10px',
                  }}
                />
              ) : (
                <TbSortAscendingNumbers
                  style={{
                    color: '#41025F',
                    fontSize: '20px',
                    marginLeft: '10px',
                  }}
                />
              )}
            </p>
            <p className="mainText">Action</p>
          </div>
        </div>
      </div>
    );
  };

  const ViewBarForMobile = () => {
    return (
      <div className="sorting">
        <div>
          <label className="labIcon">Filters</label>
        </div>
        <div>
          <p onClick={handleCsrIcon} className="sort-item">
            CSR
            {sortingOrder === 'asc' ? (
              <TbSortAscendingNumbers
                style={{
                  color: '#430643',
                  fontSize: '15px',
                  marginLeft: '2px',
                }}
              />
            ) : (
              <TbSortDescendingNumbers
                style={{
                  color: '#430643',
                  fontSize: '15px',
                  marginLeft: '2px',
                }}
              />
            )}
          </p>
          <p
            onClick={handlePremiumIcon}
            className="sort-item"
            style={{ marginLeft: '10px' }}
          >
            Premium
            {sortingOrder === 'desc' ? (
              <TbSortDescendingNumbers
                style={{
                  color: '#41025F',
                  fontSize: '15px',
                  marginLeft: '2px',
                }}
              />
            ) : (
              <TbSortAscendingNumbers
                style={{
                  color: '#41025F',
                  fontSize: '15px',
                  marginLeft: '2px',
                }}
              />
            )}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div>
      <MainContainer>
        <FilterBar
          loading={loading}
          setLoading={setLoading}
          CallQuoteAPIs={callQuoteAPIs}
        />
        {loading ? (
          <SkeletonContainer>
            <SkeletonComponent />
            <SkeletonComponent />
            <SkeletonComponent />
            <SkeletonComponent />
            <SkeletonComponent />
            <SkeletonComponent />
            <SkeletonComponent />
          </SkeletonContainer>
        ) : (
          <>
            {screenWidth > 1024 ? <ViewBar /> : <ViewBarForMobile />}
            {selectedView === 'list' ? (
              healthQuoteState.length > 0 &&
              healthQuoteState.map((item, index) => {
                return (
                  <PlanCard
                    key={item.id}
                    item={item}
                    viewMoreDetails={viewMoreDetails}
                    setViewMoreDetails={setViewMoreDetails}
                    setDetailsInfo={setDetailsInfo}
                  />
                );
              })
            ) : (
              <div className="grid gtc-4 mt-1">
                {healthQuoteState.length > 0 &&
                  healthQuoteState.map((item, index) => {
                    return (
                      <PlanCard
                        key={item.id}
                        item={item}
                        viewMoreDetails={viewMoreDetails}
                        setViewMoreDetails={setViewMoreDetails}
                        setDetailsInfo={setDetailsInfo}
                      />
                    );
                  })}
              </div>
            )}
          </>
        )}
      </MainContainer>
      <Pagination total={1} currentPage={1} pageSize={10} />
      <Footer />
      {detailsInfo > -1 && (
        <>
          <ViewDetailsPopup
            item={detailsInfo}
            setDetailsInfo={setDetailsInfo}
            setUpdateCover={false}
          />
        </>
      )}
    </div>
  );
};
